import moment from "moment";
import fileDoc from "../assets/images/attachments/doc.png";
import fileUnknown from "../assets/images/attachments/file.png";
import filePdf from "../assets/images/attachments/pdf.png";
import fileSheet from "../assets/images/attachments/sheet.png";
import fileZip from "../assets/images/attachments/zip.png";
import {
  FileType,
  IConversationMessage,
  IFileAttachment,
  INewConversationMessage,
  ISentMessage,
  MsgActionType,
  MsgType,
} from "../types/webchatConversation";
import { MATCH_NOT_FOUND } from "./constants";

const monthNames = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

// const dayNames = [
//   "monday",
//   "muesday",
//   "wednesday",
//   "thursday",
//   "friday",
//   "saturday",
//   "sunday",
// ];

export const formatDate = (rawDate: string) => {
  const date = new Date(rawDate);
  return (
    date.getDate() +
    "/" +
    (date.getMonth() + 1) +
    "/" +
    date.getFullYear().toString().substr(2, 2)
  );
};

export const formatFullDate = (rawDate: string) => {
  const date = new Date(rawDate);
  return (
    date.getDate() +
    ". " +
    monthNames[date.getMonth()] +
    " " +
    date.getFullYear().toString() +
    "."
  );
};

export const formatTime = (rawDate: string) => {
  const date = new Date(rawDate);
  const hours =
    date.getHours() < 10 ? "0" + date.getHours() : "" + date.getHours();
  const mins =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : "" + date.getMinutes();

  return hours + ":" + mins;
};

export const getUsername = (chatMessage: IConversationMessage): string => {
  switch (chatMessage.action) {
    case MsgActionType.AGENT_RESPONSE:
    case MsgActionType.RESPOND:
    case MsgActionType.LOG:
      return chatMessage.msg.name;
    default:
      return "FireCo";
  }
};

export const getPlacement = (chatMessage: IConversationMessage) => {
  switch (chatMessage.action) {
    case MsgActionType.AGENT_RESPONSE:
    case MsgActionType.BOT_RESPONSE:
      return "left";
    default:
      return "right";
  }
};

export const getAvatar = (chatMessage: IConversationMessage) => {
  switch (chatMessage.action) {
    case MsgActionType.AGENT_RESPONSE:
    case MsgActionType.RESPOND:
    case MsgActionType.LOG:
      return (
        chatMessage.msg.avatar ||
        "https://www.2700chess.com/img/avatar/noavatar.png"
      );
    case MsgActionType.BOT_RESPONSE:
      return "/logo-redo.png";
    default:
      return "https://www.2700chess.com/img/avatar/noavatar.png";
  }
};

export const findExtension = (media: any) => {
  if (!media || typeof media !== "string") {
    return "";
  }

  const index = media.lastIndexOf(".") + 1;
  const extension = media.substring(index);

  return extension;
};

export const selectFileImage = (extension) => {
  if (extension === FileType.PDF) {
    return filePdf;
  }
  if (
    extension === FileType.ZIP ||
    extension === FileType.RAR ||
    extension === FileType.SZIP
  ) {
    return fileZip;
  }
  if (
    extension === FileType.XLSX ||
    extension === FileType.XLS ||
    extension === FileType.CSV ||
    extension === FileType.ODS
  ) {
    return fileSheet;
  }
  if (
    extension === FileType.DOC ||
    extension === FileType.DOCX ||
    extension === FileType.TXT ||
    extension === FileType.RTF ||
    extension === FileType.ODT
  ) {
    return fileDoc;
  }

  return fileUnknown;
};
//stari izraz
// const buttonTextRegEx = new RegExp(
//   "(?<=>)([a-zA-Z\u0400-\u04FF\u010C\u010D\u0106\u0107\u017D\u017E\u0160\u0161\u0110\u01110-9]+[\\s*[a-zA-Z\u0400-\u04FF\u010C\u010D\u0106\u0107\u017D\u017E\u0160\u0161\u0110\u01110-9]*]*)(?=<){1}",
// );

const buttonTextRegEx = new RegExp(
  "(?<=>)([a-zA-Z\u0400-\u04FF\u010C\u010D\u0106\u0107\u017D\u017E\u0160\u0161\u0110\u01110-9\u2003]+[\\s*[a-zA-Z\u0400-\u04FF\u010C\u010D\u0106\u0107\u017D\u017E\u0160\u0161\u0110\u01110-9]*]*)(?=<|<br>){1}",
);

export const parseButtonText = (btnText: string) => {
  if (!btnText) return MATCH_NOT_FOUND;

  // 1. Zameni <br> sa razmakom
  const cleanedText = btnText.replace(/<br\s*\/?>/gi, " ");

  // 2. Primeni RegExp
  const foundText = buttonTextRegEx.exec(cleanedText);
  let extractedText = foundText ? foundText[0] : MATCH_NOT_FOUND;

  // 3. Ukloni sve vrste neželjenih razmaka (uključujući nevidljive)
  extractedText = extractedText
    .replace(/[\s\u2003\u00A0]+/g, " ") // Zameni sve vrste razmaka sa jednim " "
    .trim(); // Ukloni razmake sa početka i kraja

  return extractedText;
};

export const parseButtonValue = (btnValue: string) => {
  const foundValue = btnValue.substring(btnValue.indexOf(">") + 1);

  return foundValue;
};

export const createNewMessage = (
  value: string,
  fileAttachment?: IFileAttachment,
) => {
  // Detektuj da li je slika na osnovu mimeType ili ekstenzije
  let messageType = MsgType.TEXT;

  if (fileAttachment) {
    const isImage =
      fileAttachment.mimeType?.startsWith("image/") ||
      /\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(fileAttachment.fileName);

    messageType = isImage ? MsgType.PICTURE : MsgType.FILE;
  }

  const message: INewConversationMessage = {
    msg: {
      text: value,
      file: fileAttachment,
    },
    type: messageType,
  };

  return message;
};

export const createSentMessage = (
  text: string,
  name: string,
  avatar: string,
  type: MsgType = MsgType.TEXT,
) => {
  const message: ISentMessage = {
    msg: {
      name,
      avatar,
      text,
    },
    type,
    createdAt: moment().toDate().toString(),
    action: MsgActionType.RESPOND,
    sentMsg: true,
  };
  return message;
};

export const createObjForCookie = () => {
  const isLocal = process.env.REACT_APP_IS_LOCAL;
  if (isLocal && isLocal === "true") {
    return { path: "/" };
  }

  return {
    path: "/",
    sameSite: "none",
    secure: true,
  };
};
